import { useLocation } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import type { AllProductUpdatesQuery } from 'generated/resources/graphql'
import moment from 'moment'

import Buttons from 'modules/product_updates/components/Buttons'
import Media from 'modules/product_updates/components/ListSection/_Item/_Media'

type ProductUpdatesUpdate =
  AllProductUpdatesQuery['productUpdates']['updatesConnection']['edges'][number]['node']

const Item = ({
  title,
  shortDescription,
  thumbnail,
  productModule,
  slug,
  releaseDate,
  featureRelated,
  id,
  chargebeeModuleName,
  media,
  navigationSlug,
}: ProductUpdatesUpdate) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const rawUpsellOrigin = queryParams.get('upsell_origin')
  // Remove leading underscore if present
  const upsellOrigin = rawUpsellOrigin?.startsWith('_') ? rawUpsellOrigin.slice(1) : rawUpsellOrigin

  const today = moment().startOf('day')
  const isAlreadyReleased = today.isSameOrAfter(releaseDate)
  const featureIdentifier = featureRelated?.featureIdentifier || ''

  const productUpdateMedia = (): { alt: string; url: string; video?: boolean }[] => {
    return (
      media?.map((item) => {
        const imgObj = {
          url: item.video?.mp4Url || item.url || '',
          alt: '',
          video: !!item.video?.mp4Url || item.url?.includes('.mp4'),
        }
        return imgObj
      }) || []
    )
  }

  const [video] = productUpdateMedia()
  return (
    <Box
      flexDirection="column"
      gap="s16"
      style={{ boxShadow: '0px 2px 20px 0px rgba(13, 22, 37, 0.04)' }}
      borderRadius={{
        all: 'abs016',
      }}
      border={{
        all: {
          width: 's1',
          color: 'grey300',
          style: 'solid',
        },
      }}
      padding="s16"
    >
      <Media video={video} thumbnail={thumbnail} title={title} />
      <Box flexDirection="column" gap="s16" style={{ flex: '1', justifyContent: 'space-between' }}>
        <Box flexDirection="column" gap="s16">
          <Box width="fit-content">
            <F0TagRaw text={productModule?.name || '-'} />
          </Box>
          <Box gap="s2">
            <span className="text-lg font-semibold">{title}</span>
            <span className="text-lg text-f1-foreground-secondary">{shortDescription}</span>
          </Box>
        </Box>
        <Box flexDirection="row">
          <Buttons
            chargebeeModuleName={chargebeeModuleName}
            productUpdateSlug={slug}
            isAlreadyReleased={isAlreadyReleased}
            productUpdateId={id}
            featureIdentifier={featureIdentifier}
            version="factorial-one"
            navigationSlug={navigationSlug || undefined}
            source={`From product news ${slug} ${upsellOrigin ? ` - ${upsellOrigin}` : ''}`}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Item
